import React from 'react';
import { PaintbrushIcon, PaletteIcon, SparklesIcon, LightbulbIcon, WrenchIcon, LayoutGridIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Pintado completo de vehículos',
    description: 'Renovamos por completo la pintura de tu vehículo con acabado de fábrica, utilizando materiales premium y cabinas de última generación.',
    icon: PaintbrushIcon,
    image: 'https://cdn.magicpatterns.com/uploads/nimjoJ3grqR5xupg1cDe7T/heylloyd-image-1774620623703.png'
  }, {
    title: 'Cambio de color',
    description: 'Transforma tu vehículo con el color que siempre soñaste. Acabados mate, brillo, metalizados o perlados con precisión absoluta.',
    icon: PaletteIcon,
    image: 'https://cdn.magicpatterns.com/uploads/mDYv6S7f26FVPD68uU43UM/heylloyd-image-1774620788369.png'
  }, {
    title: 'Pulido completo',
    description: 'Eliminamos imperfecciones, microarañazos y devolvemos el brillo original a la carrocería, protegiéndola con tratamientos cerámicos.',
    icon: SparklesIcon,
    image: 'https://cdn.magicpatterns.com/uploads/cRngAU39Vt1d5A8yeyLqz4/heylloyd-image-1774620675613.png'
  }, {
    title: 'Restauración de faros',
    description: 'Faros como nuevos. Eliminamos la opacidad y el tono amarillento, mejorando drásticamente la visibilidad y estética de tu coche.',
    icon: LightbulbIcon,
    image: 'https://cdn.magicpatterns.com/uploads/mSmfYpGP1MNTTy8g1uz3Kk/heylloyd-image-1774620971975.png'
  }, {
    title: 'Reparación de golpes y arañazos',
    description: 'Reparamos todo tipo de daños en la carrocería, desde pequeños roces hasta abolladuras importantes, devolviendo la forma original.',
    icon: WrenchIcon,
    image: 'https://cdn.magicpatterns.com/uploads/8fQqStzrtLzCco5MD7u8Vv/heylloyd-image-1774620964020.png'
  }, {
    title: 'Pintado por piezas',
    description: 'Puerta trasera, paragolpes, aleta, capó, techo, retrovisor, rejilla y más. Igualación perfecta de color garantizada.',
    icon: LayoutGridIcon,
    image: 'https://cdn.magicpatterns.com/uploads/nimjoJ3grqR5xupg1cDe7T/heylloyd-image-1774620623703.png'
  }];
  return <section id="servicios" className="relative bg-[#0A0A0A] py-24 overflow-hidden" data-id="element-239">
      {/* Background image with heavy overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/nimjoJ3grqR5xupg1cDe7T/heylloyd-image-1774620623703.png')"
    }} data-id="element-240"></div>

      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-red-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-241"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-242"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="text-center mb-16" data-id="element-244">
          <h2 className="text-3xl font-bold text-white sm:text-4xl" data-id="element-245">
            Nuestros Servicios
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 bg-gradient-to-r from-blue-600 to-red-500 rounded-full" data-id="element-246"></div>
          <p className="mt-4 text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-247">
            Ofrecemos soluciones integrales para la estética de tu vehículo,
            garantizando resultados impecables y duraderos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-248">
          {services.map((service, index) => <div key={index} className="group relative bg-[#1a1a1a] rounded-xl overflow-hidden border-l-4 border-transparent hover:border-blue-600 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(59,130,246,0.15)]" data-id="element-249">
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden" data-id="element-250">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-251" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/40 to-transparent" data-id="element-252"></div>
                <div className="absolute top-4 left-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-blue-600/90 text-white shadow-lg backdrop-blur-sm" data-id="element-253">
                  <service.icon className="h-6 w-6" data-id="element-254" />
                </div>
              </div>

              {/* Service Content */}
              <div className="p-6" data-id="element-255">
                <h3 className="mb-3 text-xl font-bold text-white" data-id="element-256">
                  {service.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-257">
                  {service.description}
                </p>
              </div>

              {/* Decorative corner glow on hover */}
              <div className="absolute -bottom-2 -right-2 w-24 h-24 bg-blue-600/20 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-258"></div>
            </div>)}
        </div>
      </div>
    </section>;
}